/*
 * @Author: cc
 * @Date: 2020-01-12 16:20:11
 * @LastEditTime: 2020-08-21 16:26:05
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\newspaperRemark\left\left.js
 * @Description: 读报评报左侧导航
 */
angular.module('newspaperRemarkLeftModule', []).controller('NewspaperRemarkLeftCtrl', [
    '$scope',
    '$state',
    '$filter',
    'editingCenterService',
    'editingMediatype',
    '$q',
    'messagePublishService',
    function ($scope, $state, $filter, editingCenterService, editingMediatype, $q, messagePublishService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                expandedLeve1: [],
                // 因为有两种展现方式，左边需要传保存对应的类型
                typeName: '',
                type: $state.params.type || 'pbl',
            };
            $scope.data = {
                leftItems: [], // 用这个数组去编辑左侧报纸集合，这里不是树结构，是一个集合
                paperid: $state.params.paperid || '', // 报纸的id,用来高亮当前栏目
                pblChildren: [
                    {
                        name: '手工评报栏',
                        type: 'sd',
                    },
                    {
                        name: '可视化评报栏',
                        type: 'zd',
                    }
                ],
                selectedPaper: {},
            };
        }

        /**
         * [initData description]初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            editingCenterService.querySitesByMediaType(editingMediatype.newspaper).then((data) => {
                if (data.DATA && data.DATA.length) {
                    $scope.data.leftItems = data.DATA;
                    autoLocation();
                }
            });
        }

        /**
         * [selectNewspaper description] 选择报纸
         * @param   {[object]}  paper  [paper description]选择的报纸信息
         * @return  {[type]}           [return description]
         */
        $scope.selectNewspaper = function (paper) {
            $scope.$root.narrowNavigation = true; // 宽导航
            $scope.status.type = 'pbgl';
            routerToList(paper);
        };

        $scope.selectpbl = function (paper) {
            $scope.$root.narrowNavigation = false; // 窄导航
            $scope.status.type = 'pbl';
            routerToList(paper);
        };

        /**
         * [expandPbglClassify description]展开一级菜单
         *
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.expandPbglClassify = function (type) {
            let deffer = $q.defer();
            $scope.expandLeve1(type);
            deffer.resolve();
            return deffer.promise;
        };

        /**
         * [expandLeve1 description] 展开一级菜单
         * @param  {[type]} type [description] 菜单类型
         * @return {[type]}      [description]
         */
        $scope.expandLeve1 = function (type) {
            let deffer = $q.defer();
            if ($scope.leve1IsExpanded(type)) {
                $scope.status.expandedLeve1 = $scope.status.expandedLeve1.filter((item) => item.indexOf(type) < 0);
                deffer.resolve();
            } else {
                $scope.status.expandedLeve1.push(type);
                deffer.resolve();
            }
            return deffer.promise;
        };

        /**
         * [leve1IsExpanded description] 判断一级菜单是否展开
         * @param   {[type]}  type  [type description] 菜单类型
         * @return  {[type]}        [return description]
         */    
        $scope.leve1IsExpanded = function (type) {
            return $scope.status.expandedLeve1.some((item) => item.indexOf(type) >= 0);
        };

        /**
         * [autoLocation description] 路由定位
         * @return  {[undefined]}     [return description]
         */
        function autoLocation() {
            let type = $state.params.type;
            if (!type) {
                // 第一次进来的时候不存在任何路由 则需要自动定位到左侧第一个
                $scope.expandLeve1('pbl').then(() => {
                    routerToList($scope.data.leftItems[0]);
                });
                messagePublishService.publish('routerToNewspaperRemarkList', 'true');
            } else {
                if (type === 'pbgl'){
                    dealPbglRouter();
                } else {
                    $scope.expandLeve1(type);
                }
            }
        }

        /**
         * [dealPbglRouter description] 处理评报栏路由
         * @return  {[type]}  [return description]
         */
        function dealPbglRouter(){
            $scope.$root.narrowNavigation = true; // 宽导航
            $scope.expandLeve1($state.params.type);
            let selectPaper = $scope.data.leftItems[0];
            if ($state.params.paperid) {
                selectPaper = $filter('filterBy')($scope.data.leftItems, ['SITEID'], $scope.data.paperid)[0];
            }
            routerToList(selectPaper);
        }
        
        /**
         * [routerToList description] 跳转到列表页
         * @param   {[object]}  paper  [paper description] 报纸信息
         * @return  {[type]}           [return description]
         */
        function routerToList(paper) {
            $scope.data.selectedPaper = paper;
            // 此处用于 更改url
            $scope.data.paperid = $state.params.paperid = paper.SITEID;
            $state.params.type = $scope.status.type;
            $state.params.typetwo = $state.params.typetwo || 'sd';
            $state.params.sitename = $scope.data.selectedPaper.SITEDESC;
            $state.params.change = Math.random(0, 1) * 100;
            // 此处用于 高亮定位的参数
            $state.transitionTo('newspaperRemark.toolbar', $state.params, {
                reload: false
            });
            $state.reload($state.current);
        }
    },
]);
